import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';

const Home                 = lazy(() => import('./pages/Home'));
const BackOffice           = lazy(() => import('./pages/BackOffice'));
const BackOfficeArea       = lazy(() => import('./pages/BackOfficeArea'));
const DiningVenues         = lazy(() => import('./pages/DiningVenues'));
const DiningArea           = lazy(() => import('./pages/DiningArea'));
const Spa                  = lazy(() => import('./pages/Spa'));
const Golf                 = lazy(() => import('./pages/Golf'));
const GolfArea             = lazy(() => import('./pages/GolfArea'));
const Deliveries           = lazy(() => import('./pages/Deliveries'));
const Tennis               = lazy(() => import('./pages/Tennis'));
const SalesCatering        = lazy(() => import('./pages/SalesCatering'));
const Engagement           = lazy(() => import('./pages/Engagement'));
const ContinuousConnections = lazy(() => import('./pages/ContinuousConnections'));
const Solution             = lazy(() => import('./pages/Solution'));
const AboutUs              = lazy(() => import('./pages/AboutUs'));

function App() {
  return (
    <Suspense fallback={null}>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />

        {/* Back Office main map + sub-areas */}
        <Route path="backoffice" element={<BackOffice />} />
        <Route path="backoffice/lobby" element={<BackOfficeArea area="lobby" />} />
        <Route path="backoffice/pool" element={<BackOfficeArea area="pool" />} />
        <Route path="backoffice/gran-n-go" element={<BackOfficeArea area="market" />} />
        <Route path="backoffice/gifts" element={<BackOfficeArea area="gifts" />} />
        <Route path="backoffice/office" element={<BackOfficeArea area="office" />} />
        <Route path="backoffice/valet" element={<BackOfficeArea area="valet" />} />
        <Route path="backoffice/shipping" element={<BackOfficeArea area="shipping" />} />
        <Route path="backoffice/guest" element={<BackOfficeArea area="guest" />} />
        <Route path="backoffice/inventory" element={<BackOfficeArea area="inventory" />} />

        {/* Dining Venues and sub-areas */}
        <Route path="dining" element={<DiningVenues />} />
        <Route path="dining/restaurant" element={<DiningArea area="restaurant" />} />
        <Route path="dining/casual" element={<DiningArea area="casual" />} />
        <Route path="dining/kitchen" element={<DiningArea area="kitchen" />} />
        <Route path="dining/buffet" element={<DiningArea area="buffet" />} />
        <Route path="dining/foodcourt" element={<DiningArea area="foodcourt" />} />
        <Route path="dining/employeedining" element={<DiningArea area="employeedining" />} />

        {/* Top-level venue pages */}
        <Route path="spa" element={<Spa />} />
        <Route path="golf" element={<Golf />} />
        <Route path="golf/cart" element={<GolfArea area="cart" />} />
        <Route path="golf/hall" element={<GolfArea area="hall" />} />
        <Route path="golf/club" element={<GolfArea area="club" />} />
        <Route path="golf/shop" element={<GolfArea area="shop" />} />
        <Route path="deliveries" element={<Deliveries />} />
        <Route path="tennis" element={<Tennis />} />
        <Route path="conference" element={<SalesCatering />} />
        <Route path="engagement" element={<Engagement />} />
        <Route path="connection" element={<ContinuousConnections />} />

        {/* Solution detail pages */}
        <Route path="solutions/:id" element={<Solution />} />
        <Route path="aboutus" element={<AboutUs />} />
        <Route path="aboutus/agilysys" element={<AboutUs />} />
      </Route>
    </Routes>
    </Suspense>
  );
}

export default App;
